import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * Thin gradient progress bar fixed to the top of the viewport, filling left to
 * right as the user scrolls the page. Uses framer-motion's useScroll (which
 * measures window scroll) with a spring for buttery motion.
 */
const ScrollProgressBar = ({ height = 3 }) => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 130, damping: 24, mass: 0.4 });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[10000] origin-left pointer-events-none"
      style={{
        height,
        scaleX,
        background: 'linear-gradient(90deg, #3b82f6 0%, #06b6d4 45%, #10b981 100%)',
        boxShadow: '0 0 12px rgba(59,130,246,0.5)',
      }}
      aria-hidden="true"
    />
  );
};

export default ScrollProgressBar;
